import React from "react";
import { Link } from "gatsby";
import resolveLink from "src/utils/resolveLink";

const FeaturedLink = (item) => {
  return (
    <div className="flex-1">
      <Link
        className="font-body text-blue hover:text-red group text-xs transition duration-300"
        to={resolveLink(`/${item.target.cached_url}`)}
      >
        <img
          className="mb-2 rounded transition duration-300 group-hover:opacity-80"
          src={
            item.image.filename
              ? item.image.filename
              : "https://via.placeholder.com/550x500"
          }
          alt={item.name}
        />
        {item.name}
      </Link>
    </div>
  );
};

export default FeaturedLink;
